var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewFilledNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 13.333H1.334V12h.667V7.354c0-3.325 2.686-6.02 6-6.02 3.313 0 6 2.695 6 6.02V12h.666v1.333zM6.334 14h3.333a1.667 1.667 0 01-3.333 0z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/new-filled-notification.svg";
export { SvgNewFilledNotification as ReactComponent };